// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__1BBY0","innerBox":"Signup_innerBox__yGXTl","footer":"Signup_footer__aIOAS","error":"Signup_error__ek3CY","password":"Signup_password__XvD9h"};